// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.barcode-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(116deg, #1e1f20 0%, #313a4c 50%, #101d4a 100%);
  font-family: "Inter", sans-serif;
  color: #fff;
  overflow-x: hidden;
}

#qr-region {
  margin: 0 16px;
  margin-top: 12px;
  width: calc(100% - 32px);
  max-width: 100%;
  background: linear-gradient(116deg, #1e1f20 0%, #313a4c 50%, #101d4a 100%);
  border-radius: 16px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.45);
  overflow: hidden;
}

#qr-region video,
#qr-region canvas {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: inherit;
}

.fab-container {
  position: fixed;
  right: 16px;
  bottom: 96px;
  z-index: 100;
}

.fab {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  font-size: 28px;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: transform 0.15s;
}

.fab:hover {
  transform: scale(1.06);
}

.fab.start {
  background: #28a745;
}

.fab.stop {
  background: #dc3545;
}

.submit-button {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  background: #007bff;
  color: #fff;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  padding: 16px 0;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: background 0.2s;
}

.submit-button:hover {
  background: #0067d6;
}

.product-card-wrapper {
  margin: 12px 16px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: border-color 0.2s;
}

.product-card-wrapper.highlight {
  border: 2px solid orange;
}

@media (min-width: 481px) {
  .barcode-page {
    align-items: center;
  }
  #qr-region {
    max-width: 400px;
  }
}
.qr-box {
  width: 100%;
  max-width: 380px;
  aspect-ratio: 1/1;
  margin: 0 auto 24px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.45);
}

.fab-container {
  position: fixed;
  right: 16px;
  bottom: 96px;
  z-index: 10;
}

.fab {
  appearance: none;
  border: none;
  border-radius: 50%;
  width: 64px;
  height: 64px;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.08s ease, opacity 0.2s ease, background-color 0.2s ease;
}
.fab.start {
  background: #1677ff;
}
.fab.stop {
  background: #ff4d4f;
}
.fab:active {
  transform: scale(0.96);
}
.fab:disabled, .fab[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.fab.is-loading {
  position: relative;
}
.fab .spinner {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #fff;
  animation: spin 0.8s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BarCodeScanner/BarCodeScanner.scss"],"names":[],"mappings":"AAOA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,0EAAA;EAMA,gCAAA;EACA,WAAA;EACA,kBAAA;AAXF;;AAcA;EACE,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,0EAAA;EAMA,mBAAA;EACA,0CAAA;EACA,gBAAA;AAhBF;;AAkBA;;EAEE,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,2BAAA;AAfF;;AAiBA;EACE,sBAAA;AAdF;;AAgBA;EACE,mBAnEa;AAsDf;;AAeA;EACE,mBArEW;AAyDb;;AAeA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBA5EY;EA6EZ,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;EACA,2BAAA;AAZF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,6BAAA;AAXF;;AAaA;EACE,wBAAA;AAVF;;AAaA;EACE;IACE,mBAAA;EAVF;EAYA;IACE,gBAAA;EAVF;AACF;AAaA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AAXF;;AAcA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAXF;;AAcA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,0CAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+EAAA;AAXF;AAaE;EAAU,mBAAA;AAVZ;AAWE;EAAU,mBAAA;AARZ;AAUE;EAAW,sBAAA;AAPb;AASE;EAEE,YAAA;EACA,mBAAA;EACA,oBAAA;AARJ;AAWE;EACE,kBAAA;AATJ;AAYE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,sBAAA;EACA,oCAAA;EACA,qBAAA;AAVJ;;AAcA;EAAkB;IAAK,yBAAA;EATrB;AACF","sourcesContent":["$blue-900: #101d4a;\n$blue-800: #1e1f20;\n$blue-700: #313a4c;\n$accent-green: #28a745;\n$accent-red: #dc3545;\n$accent-blue: #007bff;\n\n.barcode-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(\n    116deg,\n    $blue-800 0%,\n    $blue-700 50%,\n    $blue-900 100%\n  );\n  font-family: \"Inter\", sans-serif;\n  color: #fff;\n  overflow-x: hidden;\n}\n\n#qr-region {\n  margin: 0 16px;\n  margin-top: 12px;\n  width: calc(100% - 32px);\n  max-width: 100%;\n  background: linear-gradient(\n    116deg,\n    $blue-800 0%,\n    $blue-700 50%,\n    $blue-900 100%\n  );\n  border-radius: 16px;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.45);\n  overflow: hidden;\n}\n#qr-region video,\n#qr-region canvas {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover;\n  border-radius: inherit;\n}\n\n.fab-container {\n  position: fixed;\n  right: 16px;\n  bottom: 96px;\n  z-index: 100;\n}\n\n.fab {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  font-size: 28px;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n  transition: transform 0.15s;\n}\n.fab:hover {\n  transform: scale(1.06);\n}\n.fab.start {\n  background: $accent-green;\n}\n.fab.stop {\n  background: $accent-red;\n}\n\n.submit-button {\n  position: fixed;\n  left: 16px;\n  right: 16px;\n  bottom: 16px;\n  background: $accent-blue;\n  color: #fff;\n  font-weight: 600;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 0;\n  font-size: 16px;\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  transition: background 0.2s;\n}\n.submit-button:hover {\n  background: darken($accent-blue, 8%);\n}\n\n.product-card-wrapper {\n  margin: 12px 16px;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  transition: border-color 0.2s;\n}\n.product-card-wrapper.highlight {\n  border: 2px solid orange;\n}\n\n@media (min-width: 481px) {\n  .barcode-page {\n    align-items: center;\n  }\n  #qr-region {\n    max-width: 400px;\n  }\n}\n\n.qr-box {\n  width: 100%;\n  max-width: 380px;\n  aspect-ratio: 1 / 1;\n  margin: 0 auto 24px;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.45);\n}\n\n.fab-container {\n  position: fixed;\n  right: 16px;\n  bottom: 96px;\n  z-index: 10;\n}\n\n.fab {\n  appearance: none;\n  border: none;\n  border-radius: 50%;\n  width: 64px;\n  height: 64px;\n  font-size: 24px;\n  color: #fff;\n  cursor: pointer;\n  box-shadow: 0 8px 20px rgba(0,0,0,.25);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform .08s ease, opacity .2s ease, background-color .2s ease;\n\n  &.start { background: #1677ff; }\n  &.stop  { background: #ff4d4f; }\n\n  &:active { transform: scale(.96); }\n\n  &:disabled,\n  &[disabled] {\n    opacity: .6;\n    cursor: not-allowed;\n    pointer-events: none; // <— клики не проходят\n  }\n\n  &.is-loading {\n    position: relative;\n  }\n\n  .spinner {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    border: 2px solid rgba(255,255,255,.45);\n    border-top-color: #fff;\n    animation: spin .8s linear infinite;\n    display: inline-block;\n  }\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
